export default "__VITE_PUBLIC_ASSET__755fdbdf__"